import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        mensaje: '',

        //overlay
        overlay: false,

        loading: false,

        loadBar: false,

        //snackbar
        message: '',
        type: '',
        show: false
    },

    getters: {
        overlay(state) {
            return state.overlay
        },
        loading(state) {
            return state.loading
        },

        // getters SnackBar
        snackShow(state) {
            return state.show
        },
        snackType(state) {
            return state.type
        },
        snackMessage(state) {
            return state.message
        },
        mensaje(state) {
            return state.mensaje
        },
        loadBar(state) {
            return state.loadBar
        }

    },
    mutations: {
        setOverlay(state) {
            state.overlay = true
        },
        setLoadBar(state, payload) {
            state.loadBar = payload
        },
        setMensajeAlerta(state, payload) {
            state.mensaje = payload.message
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setSnack(state, payload) {
            state.show = true
            state.message = payload.message
            state.type = payload.type
            setTimeout(() => {
                state.show = false
                state.message = ''
                state.type = ''
            }, 9000);
        },
        setSnackHide(state) {
            state.show = false
            state.message = ''
            state.type = ''
        },
        resetSnack(state) {
            state.show = false
            state.message = ''
            state.type = ''
        }
    },
    actions: {
        //overlay
        startOverlay({ commit, dispatch }) {
            commit('setOverlay')
        },
        startLoading({ commit, dispatch }) {
            commit('setLoading', true)
        },
        stopLoading({ commit, dispatch }) {
            commit('setLoading', false)
        },
        // Actions SnackBar
        showSnack({ commit }, payload) {
            commit('setSnack', payload)
        },
        hideSnack({ commit }) {
            commit('setSnackHide')
        },
        resetSnack({ commit }) {
            commit(resetSnack)
        },
        mensajeAlerta({ commit, dispatch }, payload) {
            commit('setMensajeAlerta', payload)
        }
    }
})